import { render, staticRenderFns } from "./ModalCallCenter.vue?vue&type=template&id=64edbb62&"
import script from "./ModalCallCenter.vue?vue&type=script&lang=js&"
export * from "./ModalCallCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports